import React from 'react';
import { upperFirst } from 'lodash';
import { compose } from 'recompose';

import NotificationContent from '../../shared/AppointmentContainer';
import Header from './components/Header';
import Footer from '../../shared/Footer';
import Logo from '../../shared/Logo';
import PhonesBackground from '../../shared/PhonesBackground';
import SquireInfo from '../../shared/SquireInfo';
import PostCtaAction from './components/PostCtaAction';
import Cta from './components/Cta';
import withLoyaltyNotification from '../../hoc/withLoyaltyNotification';
import withAppointmentNotification from '../../hoc/withAppointmentNotification';
import LoyaltyCode from './components/LoyaltyCode';
import Money from '../../../components/Money';

/* eslint-disable react/prop-types */
const CustomerLoyaltyGrant = ({
  shop,
  customer,
  appLink,
  loyaltyCode,
  loyaltyAmount,
  squireInfoClassName,
}) => (
  <div>
    <Header shopName={shop.name} loyaltyAmount={loyaltyAmount} />
    <NotificationContent>
      <Logo />
      <h2 className="u-text-huge u-fw-bold u-mt-10">
        Hey {upperFirst(customer.firstName)}, thank you for being a loyal customer, you just earned
        &nbsp;<Money noDecimalsIfInt>{loyaltyAmount}</Money>!
      </h2>
      <div className="u-mb-4 u-mt-12">
        <LoyaltyCode loyaltyCode={loyaltyCode} />
      </div>
      <div className="u-ta-center u-text-small u-co-grey u-mb-16">
        Use this code next time you book.
      </div>
      { shop.mobileAppCta && <Cta appLink={appLink} /> }
      { shop.mobileAppCta && <PhonesBackground name="rebook" /> }
      <div className={squireInfoClassName}>
        <SquireInfo
          standalone={!shop.mobileAppCta}
          shopName={shop.name}
          renderAction={PostCtaAction}
        />
      </div>
    </NotificationContent>
    <Footer link={appLink} />
  </div>
);

export default compose(
  withAppointmentNotification,
  withLoyaltyNotification,
)(CustomerLoyaltyGrant);



// WEBPACK FOOTER //
// ./src/app/notifications/customer/CustomerLoyaltyGrant/index.jsx